module.exports = __webpack_public_path__ + "img/search.f3ad3acb.svg";